import moment from 'moment';
import React from 'react'

export const TableRow = (props) => {
  const { userName, userPhone, numbers, cartId, amount, status, confirmAt, symbol, showTicketCode } = props;

  return (
    <tr>
      <td>
        {userName || ""}<br />
        <span><strong className={`text-primary`}>{userPhone || ""}</strong></span>
      </td>
      <td className='text-center'>{cartId}</td>
      <td className='text-center'><strong>{numbers.split('').join(' ')}</strong></td>
      {showTicketCode ? <td className='text-center'><strong>{symbol || ''}</strong></td> : null}
      <td className='text-center'>{amount}</td>
      <td className={`text-center${status === 4 ? ' text-danger' : ''}`}>{status === 4 ? 'Trúng thưởng' : 'Không trúng'}</td>
      <td className='text-center'>{moment(confirmAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()}</td>
    </tr>
  );
};